define(function (require) {
    var $ = require("jquery");
    var util = require("@modules/utils");
    // var querystring = require("querystring");

    $("#submitTestGetMember").click(function (e) {
        //var formId = window.scan.editPhone.formId;
        // var $button = $(this);
        //var $form = $("#" + formId);
        var errorCallback = function (xhr, status, errorText) {
            console.log(status);
        };
        var successCallback = function (data, status, xhr) {
            console.log(data);
        };

        var headers = {
            RequestVerificationToken: util.getRequestVerificationToken()
        };

        var updateParameters = {
            PhoneNumber: $("#number").val()
        };

        var ajaxUrl = "api/updatepreferencesbyphonenumber/updatesmspreferences";

        $.ajax({
            type: "GET",
            url: ajaxUrl,
            dataType: "json",
            data: updateParameters,
            headers: headers,
            success: successCallback,
            error: errorCallback
        });

        return true;
    });
});
